import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'lsnDate'
})
export class LsnDatePipe extends DatePipe implements PipeTransform {
    transform(value: any, format: string = 'dd-MM-yyyy'): any {
        return super.transform(value, format);
    }
}
